import { PaymentRequestButtonElement } from "@stripe/react-stripe-js";

import { PaymentMethod } from "common/types";

import LoadingContainer from "client/common/components/loading/LoadingContainer";
import ErrorMessage from "client/common/components/errors/ErrorMessage";
import {
  useCreatePaymentMethodMutation,
  useWalletPaymentMethodRequest,
} from "client/payments/hooks";

import { WalletPaymentOptions } from "../types";

import styles from "../styles/WalletPaymentButton.module.less";

type WalletPaymentButtonProps = {
  paymentOptions: WalletPaymentOptions;
  onCreate: (paymentMethod: PaymentMethod) => void;
};

const WalletPaymentButton = ({ paymentOptions, onCreate }: WalletPaymentButtonProps) => {
  const defaultError = "There was an error selecting your payment method - please try again!";

  const { mutateAsync: createPaymentMethod, error } = useCreatePaymentMethodMutation({
    onSuccess: (method) => {
      onCreate(method);
    },
  });

  const { request, isLoading } = useWalletPaymentMethodRequest({
    ...paymentOptions,
    onCreate: async (id) => {
      await createPaymentMethod({ payment_method: id });
    },
  });

  if (isLoading) {
    return <LoadingContainer />;
  }

  if (!request) {
    return null;
  }

  return (
    <div className={styles.container}>
      <PaymentRequestButtonElement options={{ paymentRequest: request }} />
      {error && <ErrorMessage>{error.errors.payment_method || defaultError}</ErrorMessage>}
    </div>
  );
};

export default WalletPaymentButton;
